<footer id="mainFooter">
  <section class="footer__nav container px-4">
    <div class="logo d-flex gap-4">
      <a id="footer-logo" class="navbar-brand" [routerLink]="['/']">
        <figure class="mb-0">
          <picture>
            <img [src]="logoUrl" alt="Logo Tele Prêmios da Sorte"
          /></picture>
        </figure>
      </a>

      <div>
        <header class="text-primary fw-bold">
          Sobre Tele Prêmios da Sorte
        </header>
        <p>
          Uma empresa do <strong>Grupo Silvio Santos</strong>, onde a sorte está
          sempre ao seu lado, com prêmios Pix na palma da sua mão.
        </p>
      </div>
    </div>

    <app-social-media-list class="social-media" />

    <div class="internal-pages">
      <header class="text-primary fw-bold">Nosso Site</header>
      <app-internal-links [list]="footerMenu" />

      <a
        id="footer-links-repasse"
        class="normal-text"
        [href]="financialStatementsItem.url"
        target="_blank"
        rel="noopener"
        >{{ financialStatementsItem.title }}
      </a>
    </div>

    <div class="policies">
      <header class="text-primary fw-bold">
        Termos do Tele Prêmios da Sorte
      </header>
      <app-internal-links [list]="legalTermsList" />
    </div>

    <div class="contact-us">
      <header class="text-primary fw-bold">Fale com a gente</header>
      <p>
        <a
          id="footer-ajuda"
          (click)="openChatbot()"
          (keyup.enter)="openChatbot()"
          [style.font-size.px]="14"
          [attr.tabindex]="0">
          Clicando aqui</a
        >
        você pode enviar sua solicitação, dúvida ou problema.
      </p>

      <p>
        <a
          id="footer-fale-com-DPO"
          class="normal-text"
          [href]="dpoLink"
          target="_blank"
          >Fale com o DPO</a
        >
      </p>

      <p>
        <a
          *ngIf="helpItem"
          id="footer-help"
          class="normal-text"
          [routerLink]="helpItem.url"
          >{{ helpItem.title }}</a
        >
      </p>
    </div>

    <app-payment-brands class="payments" />
  </section>

  <app-footer-content class="footer__content px-4" />
</footer>
